import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const getAdvDisplaysLookup = {
  name: 'getAdvDisplaysLookup',
  state: {
    data: [],
    loading: false,
    error: '',
  },
  reducers: {
    getRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        data: [],
      };
    },

    getReceived(state, payload) {
      return {
        ...state,
        data: payload.data,
        loading: false,
        error: '',
      };
    },

    getRequestFailed(state, payload) {
      return {
        ...state,
        loading: false,
        error: payload,
      };
    },
  },
  effects: (dispatch) => ({
    async allDisplays() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const orgId = userInfo?.org_id;
        const url = `savvy/displays/adv-displays-lookup/${orgId}`;
        this.getRequested();
        const response = await http.get(url);
        if (response && response.data) {
          this.getReceived({
            data: response.data.data,
            totalCount: response.data.data.length,
          });
        }
      } catch (err) {
        this.getRequestFailed(err.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(err.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default getAdvDisplaysLookup;
